import React, { Component } from 'react';
import { Box, Typography, Button } from '@mui/material';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        bgcolor: 'white',
                        p: 3,
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="h4" color="error" gutterBottom sx={{ fontWeight: 800 }}>
                        Something went wrong.
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                        We apologize for the inconvenience. Please try refreshing the page.
                    </Typography>
                    {this.state.error && (
                        <Box component="pre" sx={{ textAlign: 'left', bgcolor: '#f5f5f5', p: 2, borderRadius: 1, overflow: 'auto', maxWidth: '100%', fontSize: '0.8rem' }}>
                            {this.state.error.toString()}
                        </Box>
                    )}
                    <Button
                        variant="contained"
                        onClick={() => window.location.reload()}
                        sx={{ mt: 3, bgcolor: '#022B44' }}
                    >
                        Refresh Page
                    </Button>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
